import { render, staticRenderFns } from "./CertVerify.vue?vue&type=template&id=d704e2ec"
import script from "./CertVerify.vue?vue&type=script&lang=js"
export * from "./CertVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports